import { QrCode, FileText, CreditCard } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { PaymentMethod } from '@/types/checkout'

interface PaymentMethodsProps {
  availableMethods: PaymentMethod[]
  selectedMethod: PaymentMethod | null
  onSelectMethod: (method: PaymentMethod) => void
}

const methodConfig = {
  pix: {
    icon: QrCode,
    title: 'PIX',
    description: 'Aprovação instantânea',
    color: 'text-teal-600 dark:text-teal-400',
    bgColor: 'bg-teal-50 dark:bg-teal-950/20',
    borderColor: 'border-teal-200 dark:border-teal-800',
  },
  boleto: {
    icon: FileText,
    title: 'Boleto Bancário',
    description: 'Até 3 dias úteis para confirmar',
    color: 'text-blue-600 dark:text-blue-400',
    bgColor: 'bg-blue-50 dark:bg-blue-950/20',
    borderColor: 'border-blue-200 dark:border-blue-800',
  },
  credit_card: {
    icon: CreditCard,
    title: 'Cartão de Crédito',
    description: 'Parcelamento disponível',
    color: 'text-purple-600 dark:text-purple-400',
    bgColor: 'bg-purple-50 dark:bg-purple-950/20',
    borderColor: 'border-purple-200 dark:border-purple-800',
  },
}

export function PaymentMethods({
  availableMethods,
  selectedMethod,
  onSelectMethod,
}: PaymentMethodsProps) {
  return (
    <div className="space-y-3">
      <h3 className="text-sm font-medium">Escolha a forma de pagamento</h3>

      <div className="grid gap-3">
        {availableMethods.map((method) => {
          const config = methodConfig[method]
          const Icon = config.icon
          const isSelected = selectedMethod === method

          return (
            <button
              key={method}
              type="button"
              onClick={() => onSelectMethod(method)}
              className={cn(
                'flex items-center gap-4 rounded-lg border-2 p-4 text-left transition-all',
                'hover:shadow-md',
                isSelected
                  ? `${config.borderColor} ${config.bgColor} ring-2 ring-offset-2 ring-primary`
                  : 'border-border bg-background hover:border-primary/50'
              )}
            >
              <div
                className={cn(
                  'flex h-12 w-12 items-center justify-center rounded-lg',
                  isSelected ? config.bgColor : 'bg-muted'
                )}
              >
                <Icon className={cn('h-6 w-6', isSelected ? config.color : 'text-muted-foreground')} />
              </div>

              <div className="flex-1">
                <h4 className="font-semibold">{config.title}</h4>
                <p className="text-sm text-muted-foreground">{config.description}</p>
              </div>

              {isSelected && (
                <div className="flex h-5 w-5 items-center justify-center rounded-full bg-primary text-primary-foreground">
                  <svg
                    className="h-3 w-3"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
              )}
            </button>
          )
        })}
      </div>
    </div>
  )
}
